// 3rd-party modules
import Chart from "react-apexcharts";
import CustomChartModal from "./chartModal";
import { Empty } from "antd";
import useTranslation from "../../../hooks/TranslationContext";

type Props = {
  options: any;
  series: any[];
  type?:
  | "line"
  | "area"
  | "bar"
  | "pie"
  | "donut"
  | "radialBar"
  | "scatter"
  | "bubble"
  | "heatmap"
  | "candlestick"
  | "boxPlot"
  | "radar"
  | "polarArea"
  | "rangeBar"
  | "rangeArea"
  | "treemap";
  width: string;
  height: any;
  openInModal?: boolean;
  title?: string;
  onClose?: () => void;
};

const CustomChart: React.FC<Props> = ({ options, series, type, width, height, title, openInModal, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    !!series.length ?
    <>
      <Chart
        options={options}
        series={series}
        type={type}
        width={width}
        height={height}
      />
      {
        !!openInModal &&
        <CustomChartModal
          options={options}
          series={series}
          type={type}
          title={title}
          open={openInModal}
          onClose={onClose ? onClose : undefined}/>
      }
    </>
    :
    <>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("noData")} />
    </>

  );
};

export default CustomChart;
